module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/JFK.857ab8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/JFK.jpg
// module id = 8FwW
// module chunks = 0